import { race } from '@canvas/abort';

export type AbortableResponse =
  | {
      status: 408;
      ok: false;
    }
  | Response;

export interface FetchWithTimeoutOptions {
  fetcher?: typeof fetch;
  timeout?: number;
}

export const fetchWithTimeout = async (
  url: string,
  requestOptions: RequestInit = {},
  { timeout = 5000, fetcher = fetch }: FetchWithTimeoutOptions = {},
): Promise<AbortableResponse> => {
  try {
    const controller = new AbortController();
    const id = setTimeout(() => controller.abort(), timeout);

    const signal = race(controller.signal, requestOptions.signal);

    const response = await fetcher(url, {
      ...requestOptions,
      signal,
    });
    clearTimeout(id);

    return response;
  } catch (error: any) {
    if (error.name === 'AbortError') {
      return {
        ok: false,
        status: 408,
      };
    }

    throw error;
  }
};
